import React from "react";

import { AW21 } from "../../../../js/database/database-aw21.js";

import TopMenuProducts from "../../../../components/topmenuproducts";
import SwiperInit from "../../../../components/SwiperInit";
import InfoItem from "../../../../components/infoItem";
import Loader from "../../../../components/loader";

import ShopifyMainComponent from "../../../../components/ShopifyMainComponent";
import GlobalMetaTags from "../../../../components/globalMetaTags";
import SizeChart from "../../../../components/sizeChart.js";

class ScrapbookJacquardShirt extends React.Component {

    render() {
        return (
            <div>
                <GlobalMetaTags
                    pageTitle={AW21.tops.ScrapbookJacquardShirt.itemName}
                />
                <Loader />
                <TopMenuProducts
                    name={AW21.tops.ScrapbookJacquardShirt.itemName}
                />
                <InfoItem
                    price={AW21.tops.ScrapbookJacquardShirt.itemPrice}
                    fabric={AW21.tops.ScrapbookJacquardShirt.itemFabric}
                />
                <SizeChart src={AW21.tops.ScrapbookJacquardShirt.sizeChart} />
                <div className="swiper-container" id="swiper">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.ScrapbookJacquardShirt.picture01}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.ScrapbookJacquardShirt.picture02}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.ScrapbookJacquardShirt.picture03}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.ScrapbookJacquardShirt.picture04}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>
                        <div className="swiper-slide">
                            <img
                                src={AW21.tops.ScrapbookJacquardShirt.picture05}
                                alt={AW21.alt}
                                loading="lazy"
                            />
                        </div>

                    </div>
                </div>
                <ShopifyMainComponent
                    divId={AW21.tops.ScrapbookJacquardShirt.shopifyDivId}
                    mainId={AW21.tops.ScrapbookJacquardShirt.shopifyId}
                />
                <SwiperInit />
            </div>
        );
    }
}

export default ScrapbookJacquardShirt;
